import {inject, Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, Router} from '@angular/router';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionGuard implements CanActivate {
  private _userService = inject(UserService);
  private _router = inject(Router);

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const requiredPermissions = (await route.data['permissions']) as string[];
    const hasAcess = this._userService.hasAnyPermission(requiredPermissions);

    if (hasAcess) {
      return true;
    }
    
    this._router.navigate(['/login']);
    return false;
  }

  //Utilização
  //   const routes: Routes = [
  //   {
  //     path: 'carteirinhas-listar',
  //     component: CarteirinhasListarComponent,
  //     canActivate: [PermissionGuard],
  //     data: { permissions: ['contratante.carteirinhas.listar'] },
  //   },
  // ];
}
